module.exports = {
	"id": "TN",
	"name": "Tunisia",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": 0.005994,
			"5": null,
			"6": null,
			"7": 0.011988,
			"8": 0.011988,
			"9": 0.005994,
			"10": 0.017982,
			"11": 0.041958,
			"12": 0.017982,
			"13": 0.011988,
			"14": 0.011988,
			"15": 0.011988,
			"16": 0.017982,
			"17": 0.011988,
			"18": 0.191808,
			"19": 0.011988,
			"20": 0.011988,
			"21": 0.011988,
			"22": 0.017982,
			"23": 0.035964,
			"24": 0.041958,
			"25": 0.011988,
			"26": 0.023976,
			"27": 0.02997,
			"28": 0.023976,
			"29": 0.053946,
			"30": 0.041958,
			"31": 0.083916,
			"32": 0.02997,
			"33": 0.065934,
			"34": 0.02997,
			"35": 0.023976,
			"36": 0.02997,
			"37": 0.023976,
			"38": 0.05994,
			"39": 0.05994,
			"40": 0.065934,
			"41": 0.053946,
			"42": 0.047952,
			"43": 0.5994,
			"44": 0.065934,
			"45": 0.071928,
			"46": 0.107892,
			"47": 0.137862,
			"48": 0.185814,
			"49": 4.009986,
			"50": 0.263736,
			"51": 1.204794,
			"52": 0.611388,
			"53": 29.592378,
			"54": 8.805186,
			"55": 0.143856,
			"56": 0.023976,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.02997,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": 0.017982,
			"13": null,
			"14": null,
			"15": 0.005994,
			"16": 0.005994,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": 0.005994,
			"31": 0.011988,
			"32": null,
			"33": 0.017982,
			"34": 0.005994,
			"35": 0.011988,
			"36": 0.011988,
			"37": 0.011988,
			"38": 0.02997,
			"39": 0.017982,
			"40": 0.011988,
			"41": 0.017982,
			"42": 0.017982,
			"43": 0.131868,
			"44": 0.047952,
			"45": 0.083916,
			"46": 0.11988,
			"47": 0.443556,
			"48": 0.395604,
			"49": 3.218778,
			"50": 0.041958,
			"51": 0.017982,
			"52": null,
			"3.5": 0.005994,
			"3.6": 0.017982
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": 0.005994,
			"35": 0.005994,
			"36": 0.065934,
			"37": 0.041958,
			"38": 0.077922,
			"39": 0.05994,
			"40": 0.845154,
			"41": 0.131868,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.011988
		},
		"safari": {
			"0": null,
			"4": 0.011988,
			"5": 0.005994,
			"6": 0.017982,
			"7": 0.023976,
			"8": 0.107892,
			"9": 0.035964,
			"10": 0.185814,
			"3.1": null,
			"3.2": null,
			"5.1": 0.047952,
			"6.1": 0.011988,
			"7.1": null,
			"9.1": 0.17982
		},
		"ios_saf": {
			"8": 0,
			"10": 1.34185990008,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.036161571607,
			"8.1-8.4": 0.0668069712739,
			"9.0-9.2": 0.0318712156536,
			"9.3": 0.486240341382
		},
		"android": {
			"3": 0,
			"4": 0.0944153126615,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0118019140827,
			"4.1": 0.340569520672,
			"4.2-4.3": 0.85142380168,
			"4.4": 1.95237378682,
			"4.4.3-4.4.4": 1.96923366408
		},
		"ie": {
			"6": 0.01332,
			"7": 0.01332,
			"8": 0.32634,
			"9": 0.17982,
			"10": 0.17316,
			"11": 0.61272,
			"5.5": null
		},
		"op_mob": {
			"0": 0.258307173614,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.00717519926706
		},
		"edge": {
			"12": 0.065934,
			"13": 0.137862,
			"14": 0.185814
		},
		"ie_mob": {
			"10": 0.190369633803,
			"11": 0.775076366197
		},
		"bb": {
			"7": 0.0190285,
			"10": null
		},
		"samsung": {
			"0": 2.611912
		},
		"and_uc": {
			"0": 0.76114
		},
		"op_mini": {
			"0": 3.48012762712
		},
		"and_chr": {
			"0": 26.686586
		},
		"and_ff": {
			"0": 0.236354
		}
	},
	"total": 97.6413465
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/TN.json
 ** module id = 663
 ** module chunks = 0
 **/